import {
  FETCHING_CUSTOM_FORM_FIELDS, FETCHING_CUSTOM_FORM_FIELDS_SUCCEEDED, FETCHING_CUSTOM_FORM_FIELDS_FAILED,
  DELETING_CUSTOM_FORM_FIELD, DELETING_CUSTOM_FORM_FIELD_SUCCEEDED, DELETING_CUSTOM_FORM_FIELD_FAILED,
  FETCHING_CUSTOM_FORM_FIELD, FETCHING_CUSTOM_FORM_FIELD_SUCCEEDED, FETCHING_CUSTOM_FORM_FIELD_FAILED,
  CREATE_CUSTOM_FORM_FIELD, CREATING_CUSTOM_FORM_FIELD_SUCCEEDED, CREATING_CUSTOM_FORM_FIELD_FAILED,
  UPDATE_CUSTOM_FORM_FIELD, UPDATING_CUSTOM_FORM_FIELD_SUCCEEDED, UPDATING_CUSTOM_FORM_FIELD_FAILED,
  INVALIDATE_CUSTOM_FORM_FIELDS
} from 'constants/actionTypes';
  
import { call, put, select, takeEvery } from 'redux-saga/effects';
import axios from 'axios';
import { createAction } from 'redux-actions';
import buildUrl from 'build-url';
import _ from 'lodash';
import { fetchPersonalizationFormField, fetchPersonalizationFormFieldFailed, fetchPersonalizationFormFieldSucceeded } from './personalization';
  
const apiUrl = `${process.env.REACT_APP_CLEVERSTORY_API_URL}/api/2.0`;
const CUSTOM_FORM_FIELD_URL = `${apiUrl}/custom_fields`;

/*
 * Fetch Custom Form Fields For Workspace
 */

export const fetchCustomFormFields = createAction(FETCHING_CUSTOM_FORM_FIELDS, (request) => {
  return request;
});

const fetchCustomFormFieldsSucceeded = createAction(FETCHING_CUSTOM_FORM_FIELDS_SUCCEEDED, (response) => {
  return response;
})

const fetchCustomFormFieldsFailed = createAction(FETCHING_CUSTOM_FORM_FIELDS_FAILED, (error) => {
  return error;
})

function* fetchCustomFormFieldsSaga(action) {
  const request = action.payload;

  let url = `${CUSTOM_FORM_FIELD_URL}/forms/search`;
  const isPersonalization = Array.isArray(request.ignoreTypes) && request.ignoreTypes.length > 0;

  const fetchCustomFormFieldsAPI = () => {
    return axios.post(url, request ).then(response => response.data);
  };  

  try {
    if (isPersonalization) {
      yield put(fetchPersonalizationFormField(request));
    }
    const response = yield call(fetchCustomFormFieldsAPI);
    if (response) {
      if (isPersonalization) {
        yield put(fetchPersonalizationFormFieldSucceeded(response));
      } else {
        yield put(fetchCustomFormFieldsSucceeded(response));
      }
    }
  } catch (error) {
    if (isPersonalization) {
      yield put(fetchPersonalizationFormFieldFailed(error));
    } else {
      yield put(fetchCustomFormFieldsFailed(error));
    }
  }
}

/*
 * Delete a Custom Form Field
 */

export const deleteCustomFormField = createAction(DELETING_CUSTOM_FORM_FIELD, (storyboard, id) => {
  return {
    storyboard: storyboard,
    id: id
  }
});

const deleteCustomFormFieldSucceeded = createAction(DELETING_CUSTOM_FORM_FIELD_SUCCEEDED, (response) => {
  return response;
})

const deleteCustomFormFieldFailed = createAction(DELETING_CUSTOM_FORM_FIELD_FAILED, (error) => {
  return error;
})

function* deleteCustomFormFieldSaga(action) {
  const { storyboard, id } = action.payload;

  const params = {
    storyboard: ''
  };

  let url = buildUrl(CUSTOM_FORM_FIELD_URL, {
    path: `/${id}`,
    queryParams: params
  });

  const deleteCustomFormFieldAPI = () => {
    return axios.delete(url).then(response => response.data);
  }

  try {
    const response = yield call(deleteCustomFormFieldAPI);
    if (response) {
      yield put(deleteCustomFormFieldSucceeded(response));
    }
  } catch (error) {
      yield put(deleteCustomFormFieldFailed(error));
  }
}

/*
 * Fetch a Custom Form Field
 */

export const fetchingCustomFormField = createAction(FETCHING_CUSTOM_FORM_FIELD, (storyboard, id) => {
  return {
    storyboard: storyboard,
    id: id
  }
});

const fetchingCustomFormFieldSucceeded = createAction(FETCHING_CUSTOM_FORM_FIELD_SUCCEEDED, (response) => {
  return response;
})

const fetchingCustomFormFieldFailed = createAction(FETCHING_CUSTOM_FORM_FIELD_FAILED, (error) => {
  return error;
})

function* fetchCustomFormFieldSaga(action) {
  const { storyboard, id } = action.payload;

  const params = {
    storyboard: ''
  };

  let url = buildUrl(CUSTOM_FORM_FIELD_URL, {
      path: `/${id}`,
      queryParams: params
    });

  const fetchCustomFormFieldAPI = () => {
    return axios.get(url).then(response => response.data);
  }

  try {
    const response = yield call(fetchCustomFormFieldAPI);
    if (response) {
      yield put(fetchingCustomFormFieldSucceeded(response));
    }
  } catch (error) {
      yield put(fetchingCustomFormFieldFailed(error));
  }
}

/*
 * Create Custom Form Field
 */

export const createCustomFormField = createAction(CREATE_CUSTOM_FORM_FIELD, (storyboard, request) => {
  return {
    storyboard: storyboard,
    request: request
  }
});
  
const createCustomFormFieldSucceeded = createAction(CREATING_CUSTOM_FORM_FIELD_SUCCEEDED, (request, response) => {
  return {
    request: request,
    response: response
  }
});

const createCustomFormFieldFailed = createAction(CREATING_CUSTOM_FORM_FIELD_FAILED, (request, error) => {
  return {
    request: request,
    error: error
  }
});
  
function* createCustomFormFieldSaga(action) {
  const { storyboard, request } = action.payload;

  const params = {
    storyboard: ''
  };

  let url = buildUrl(CUSTOM_FORM_FIELD_URL, {
    queryParams: params
  });

  const createCustomFormFieldAPI = () => {
    return axios.post(url, request).then(response => response.data);
  }

  try {
    const response = yield call(createCustomFormFieldAPI);
    if (response) {
        yield put(createCustomFormFieldSucceeded(request, response));
    }
  } catch (error) {
      yield put(createCustomFormFieldFailed(request, error));
  }
}

/*
 * Update Custom Form Field
 */

export const updateCustomFormField = createAction(UPDATE_CUSTOM_FORM_FIELD, (storyboard, id, request, callback) => {
  return {
    storyboard: storyboard,
    id: id,
    request: request,
    callback: callback
  }
});
  
const updateCustomFormFieldSucceeded = createAction(UPDATING_CUSTOM_FORM_FIELD_SUCCEEDED, (request, response) => {
  return {
    request: request,
    response: response
  }
});

const updateCustomFormFieldFailed = createAction(UPDATING_CUSTOM_FORM_FIELD_FAILED, (request, error) => {
  return {
    request: request,
    error: error
  }
});

function* updateCustomFormFieldSaga(action) {
  const { id, storyboard, request, callback } = action.payload;

  const params = {
    storyboard: ''
  };

  let url = buildUrl(CUSTOM_FORM_FIELD_URL, {
    path: `/${id}`,
    queryParams: params
  });

  const updateCustomFormFieldAPI = () => {
    return axios.put(url, request).then(response => response.data);
  }

  try {
    const response = yield call(updateCustomFormFieldAPI);
    if (response) {
      yield put(updateCustomFormFieldSucceeded(request, response));

      if (callback) {
        callback();
      }
    }
  } catch (error) {
    yield put(updateCustomFormFieldFailed(request, error));
  }
}

export const invalidateCustomFormFields = createAction(INVALIDATE_CUSTOM_FORM_FIELDS);

export default function* formFieldsSaga() {
  yield takeEvery(FETCHING_CUSTOM_FORM_FIELDS, fetchCustomFormFieldsSaga)
  yield takeEvery(DELETING_CUSTOM_FORM_FIELD, deleteCustomFormFieldSaga)
  yield takeEvery(FETCHING_CUSTOM_FORM_FIELD, fetchCustomFormFieldSaga)
  yield takeEvery(CREATE_CUSTOM_FORM_FIELD, createCustomFormFieldSaga)
  yield takeEvery(UPDATE_CUSTOM_FORM_FIELD, updateCustomFormFieldSaga)
}